import { render, staticRenderFns } from "./CompanyCardVerB.vue?vue&type=template&id=4afcb795&scoped=true"
import script from "./CompanyCardVerB.vue?vue&type=script&lang=ts"
export * from "./CompanyCardVerB.vue?vue&type=script&lang=ts"
import style0 from "./CompanyCardVerB.vue?vue&type=style&index=0&id=4afcb795&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afcb795",
  null
  
)

export default component.exports